module.exports = __webpack_public_path__ + "img/7.c79c323f.jpg";